require('../../modules/es.regexp.exec');
require('../../modules/es.string.match');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'match');
